const features = [
  {
    icon: "ri-shield-check-line",
    title: "Security First",
    description:
      "Every product we build is engineered with security at its core. From end-to-end encryption to zero-log policies, your privacy is never an afterthought.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Native iOS Experience",
    description:
      "We build exclusively for iOS, which means our apps are fully optimized for Apple hardware and software — delivering smooth, responsive, and battery-efficient performance.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Intuitive Design",
    description:
      "Our interfaces follow Apple&apos;s Human Interface Guidelines and go beyond — creating experiences that feel natural, elegant, and immediately familiar to any iOS user.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Peak Performance",
    description:
      "Optimized at every layer of the stack, our applications run fast and lean. We obsess over load times, memory usage, and responsiveness so users never have to wait.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    description:
      "Our team stands behind every product we ship. Users receive timely, knowledgeable support and regular updates that keep apps running perfectly on the latest iOS versions.",
  },
  {
    icon: "ri-refresh-line",
    title: "Continuous Updates",
    description:
      "The iOS ecosystem evolves rapidly. We stay ahead of every Apple release, ensuring our products are always compatible, current, and taking advantage of the latest platform features.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 md:py-36 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium">Why KIRCI DOO</span>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mt-3 tracking-tight">
            What Sets Us Apart
          </h2>
          <div className="w-12 h-px bg-gray-300 mx-auto mt-6" />
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-2xl p-8 group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-50 mb-6 group-hover:bg-gray-100 transition-colors duration-300">
                <i className={`${feature.icon} text-gray-700 text-xl`} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p
                className="text-sm text-gray-500 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: feature.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
